var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{on:{"click":function($event){_vm.data.click !== null && _vm.data.click !== undefined
        ? _vm.redirectToPage(_vm.data.click)
        : _vm.redirectToPage('Default')}}},[_c('a',{attrs:{"target":_vm.data.target,"href":_vm.data.hrefLink !== null && _vm.data.hrefLink !== undefined
          ? _vm.data.hrefLink
          : '#'}},[_vm._v(_vm._s(_vm.data.title !== null && _vm.data.title !== undefined ? _vm.data.title : "Link")),_c('q-icon',{attrs:{"name":"navigate_next"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }